export default __webpack_public_path__ + "static/natura_siberica-c88ac19fdc80dfd48b7e02c7dfd4a4b4.png";